import { request } from '../request';
// 请求示例：
// request<any>({
//   url:'',
//   method:'get', // 默认
//   data:{  }      // 请求体参数，除get请求之外的请求使用
//   params:{  }    // 请求体参数，get请求使用
// })
// 返回值：后端返回什么这里就返回什么

/**
 * 用户登录
 *
 * @param phone 手机号
 * @param password 密码(可选)
 * @param code 验证码(可选)
 */
export const fetchLogin = (params: { phone: string; password?: string; code?: string }) => {
  return request<string>({
    url: '/user/web/auth/login/',
    method: 'post',
    data: params
  });
};

/** 获取用户信息 */
export const fetchGetUserInfo = () => {
  return request<Api.Auth.UserInfo>({ url: '/user/web/userinfo/info/' });
};

/** 获取验证码 */
export const fetchCaptcha = (phone: string) => {
  return request<string>({ url: '/user/web/auth/send_code/', method: 'post', data: { phone } });
};

/** 修改密码 */
export const fetchModifyPwd = (params: { old_password: string; new_password: string }) => {
  return request<string>({ url: '/user/web/auth/change-password/', method: 'post', data: params });
};

/** 检查密码是否设置 */
export const fetchCheckPwd = () => {
  return request<any>({ url: '/user/web/auth/check-password-set/', method: 'get' });
};

/** 修改用户信息 */
export const fetchModifyUserInfo = (id: number | string, params: { name: string }) => {
  return request<any>({ url: `/user/web/auth/${id}/update/`, method: 'post', data: params });
};

/** 修改手机号 */
export const fetchModifyPhone = (params: { new_phone: string; code: string }) => {
  return request<any>({ url: `/user/web/auth/change-phone/`, method: 'post', data: params });
};
